import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    loading: false,
    inputFilters: [],
    filtersForQueries: [],
};
const { actions, reducer } = createSlice({
    name: 'tablesFilters',
    initialState,
    reducers: {
        setInputFilters: (state, { payload }) => {
            state.inputFilters = payload;
        },
        setAndApplyInputFilters: (state, { payload }) => {
            state.inputFilters = payload;
            state.filtersForQueries = payload;
        },
        resetReduxFilters: (state) => {
            state.inputFilters = [];
            state.filtersForQueries = [];
        },
    },
});
export const { setInputFilters, resetReduxFilters, setAndApplyInputFilters } = actions;
export default reducer;
